import * as React from 'react';
import {FunctionComponent} from 'react';
import createTheme from 'spectacle/lib/themes/default';
import {Deck, Heading, List, ListItem} from 'spectacle';
import {Slide} from './components/slide';
import {Global} from './model/global';
import {importCsv} from './support/import_csv';
import {Totals} from './slides/totals';
import {Costs} from './slides/costs';
import {Buffer} from './slides/buffer';
import {QuarterComparison} from './slides/quarter_comparison';
import {QuarterResultComparison} from './slides/quarter_result_comparison';
import {format} from 'date-fns';

require('normalize.css');

const theme = createTheme(
    {
        primary: 'white',
        secondary: '#1F2022',
        tertiary: '#9dadaf',
        fourth: '#F1F7F7',
    },
    {
        primary: 'BebasNeue,sans-serif',
        secondary: 'NHGDP,sans-serif',
    },
);

declare var GLOBAL: Global;

interface OwnProps {}

export const Presentation: FunctionComponent<OwnProps> = ({}) => {
    const data = GLOBAL;
    const referenceDate = new Date(2020, 8, 30);

    const months = importCsv(data.csv);

    return (
        <Deck transition={['zoom', 'slide']} transitionDuration={500} theme={theme}>
            <Slide major>
                <Heading size={1} textAlign="left" textColor="secondary">
                    Financial update Meeting
                </Heading>
                <List margin="30px 0 0" textFont="secondary" textColor="secondary" bold>
                    <ListItem>Financial update</ListItem>
                    <ListItem textColor="#C00000">Confidential</ListItem>
                </List>
            </Slide>
            <Slide>
                <Heading size={1} textAlign="left" textColor="secondary">
                    About the numbers
                </Heading>
                <List margin="30px 0 0" textFont="secondary" textColor="secondary" bold>
                    <ListItem>We aim for a stable revenue stream</ListItem>
                    <ListItem>We aim for a stable 20% profit margin</ListItem>
                    <ListItem>Not aiming for a direct revenue goal (however hitting €1m would be awesome)</ListItem>
                    <ListItem>All numbers have a reference date of {format(referenceDate, 'yyyy-MM-dd')}</ListItem>
                </List>
            </Slide>
            <Totals months={months} referenceDate={referenceDate} />
            <QuarterComparison months={months} referenceDate={referenceDate} />
            <QuarterResultComparison months={months} referenceDate={referenceDate} />
            <Costs months={months} referenceDate={referenceDate} />
            <Buffer months={months} referenceDate={referenceDate} />
            <Slide major>
                <Heading size={1} textAlign="left" textColor="secondary">
                    Thank you!
                </Heading>
            </Slide>
        </Deck>
    );
};
